import React from 'react';

const TexHubLogo = ({ className = '', size = 'default', variant = 'color' }) => {
  // Size presets - optimized after cropping whitespace
  const sizes = {
    small: { height: 28 },
    default: { height: 40 },
    large: { height: 60 },
    icon: { height: 28 },
    hero: { height: 140 },  // Hero - cropped, more compact
    navbar: { height: 36 },  // Dashboard header
    sidebar: { height: 42 },
    mobile: { height: 32 },
  };

  const currentSize = sizes[size] || sizes.default;

  // Use different logo file for hero (white text version)
  const logoSrc = variant === 'hero' 
    ? '/logo-texhub-hero.png' 
    : '/logo-texhub.png';

  // For white variant, use CSS filter to make it white (for dark backgrounds)
  const filterStyle = variant === 'white' 
    ? { filter: 'brightness(0) invert(1)' } 
    : {};

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoSrc} 
        alt="TexHub" 
        style={{ 
          height: currentSize.height,
          ...filterStyle
        }}
        className="object-contain"
      />
    </div>
  );
};

export default TexHubLogo;
